export default "__VITE_ASSET__CELJ7DEV__"